import { DEFAULT_ROOM_SETTINGS, type RoomSettings } from "@hitster/shared";

const CREATE_SETTINGS_KEY = "hitster_draft_create_settings";
const JOIN_CODE_KEY = "hitster_draft_join_code";
const JOIN_PASSWORD_KEY = "hitster_draft_join_password";
const PLACEMENT_PREFIX = "hitster_draft_placement_";

function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function writeJson(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / mode privé */
  }
}

export function getCreateRoomSettingsDraft(): RoomSettings {
  const stored = readJson<Partial<RoomSettings>>(CREATE_SETTINGS_KEY, {});
  return { ...DEFAULT_ROOM_SETTINGS, ...stored, bingo: stored.bingo ?? DEFAULT_ROOM_SETTINGS.bingo };
}

export function saveCreateRoomSettingsDraft(settings: RoomSettings): void {
  writeJson(CREATE_SETTINGS_KEY, settings);
}

export function clearCreateRoomSettingsDraft(): void {
  sessionStorage.removeItem(CREATE_SETTINGS_KEY);
}

export function getJoinCodeDraft(): string {
  return sessionStorage.getItem(JOIN_CODE_KEY) ?? "";
}

export function saveJoinCodeDraft(code: string): void {
  try {
    if (code) sessionStorage.setItem(JOIN_CODE_KEY, code);
    else sessionStorage.removeItem(JOIN_CODE_KEY);
  } catch {
    /* ignore */
  }
}

export function getJoinPasswordDraft(): string {
  return sessionStorage.getItem(JOIN_PASSWORD_KEY) ?? "";
}

export function saveJoinPasswordDraft(password: string): void {
  try {
    if (password) sessionStorage.setItem(JOIN_PASSWORD_KEY, password);
    else sessionStorage.removeItem(JOIN_PASSWORD_KEY);
  } catch {
    /* ignore */
  }
}

export function clearJoinFormDrafts(): void {
  sessionStorage.removeItem(JOIN_CODE_KEY);
  sessionStorage.removeItem(JOIN_PASSWORD_KEY);
}

export function placementDraftKey(roomCode: string, roundId: string): string {
  return `${PLACEMENT_PREFIX}${roomCode}_${roundId}`;
}

export function getPlacementDraft(roomCode: string, roundId: string): number | null {
  try {
    const raw = sessionStorage.getItem(placementDraftKey(roomCode, roundId));
    if (raw === null) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function savePlacementDraft(roomCode: string, roundId: string, index: number | null): void {
  const key = placementDraftKey(roomCode, roundId);
  try {
    if (index === null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, String(index));
  } catch {
    /* ignore */
  }
}

export function clearPlacementDraft(roomCode: string, roundId: string): void {
  try {
    sessionStorage.removeItem(placementDraftKey(roomCode, roundId));
  } catch {
    /* ignore */
  }
}
